import {React, useState} from 'react'
import { Label, TextInput, Flowbite, Button, Checkbox, Modal, Alert, FileInput } from 'flowbite-react'
import { buttonTheme } from '../components/themes'
import { createUser } from '../firebase/FirebaseManagement';
import { HiInformationCircle } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom';
import Footer  from '../components/Footer';
import { Store } from 'react-notifications-component';

export default function () {

    const navigate = useNavigate();

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [showAlertSuccess, setShowAlertSucess] = useState(false);
    const [showAlertFaliure, setShowAlertFaliure] = useState(false);
    const [file, setFile] = useState(null);


    const [openModal, setOpenModal] = useState();
    const props = { openModal, setOpenModal };

    // Event handler for first name
    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    }

    // Event handler for last name
    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    }
    // Event handler for email
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }
    // Event handler for password
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }
    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    }
    // Event handler for phone number
    const handlePhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
    }

    const signup = async (e) => {
        e.preventDefault();
        setShowAlertSucess(false);
        setShowAlertFaliure(false);
        try {
           await createUser(email, password, firstName, lastName, phoneNumber, file);
 
           Store.addNotification({
            title: "Account Created",
            message: "Your account was created successfully",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              showIcon: true
            }
          });
          navigate("/login")
            setShowAlertSucess(true);
            
        } catch (error) {
            console.log(error)
            Store.addNotification({
                title: "Account error",
                message: "There was an error while creating your account. Please try again.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  showIcon: true
                }
              });
         

        }
    }
    console.log(password, confirmPassword)
  return (
    <div className='box-container flex flex-col items-center md:w-[500px] justify-center md:mt-10 mx-auto'>
        <h1 className='text-3xl font-bold'>Create account</h1>
        {showAlertSuccess && <Alert
            color="success"
            onDismiss={()=>setShowAlertSucess(false)}
           
            >
            <span>
                <p>
                 🎉 Your account has been created successfully!
                </p>
            </span>
        </Alert>}

        {showAlertFaliure && 
        <Alert
            color="failure"
            icon={HiInformationCircle}
            onDismiss={()=>setShowAlertFaliure(false)}
        >
            <span>
            <p>
                There was an error while creating your account. Please try again.
            </p>
            </span>
        </Alert>
        }
        <form onSubmit={signup} className='flex flex-col gap-[20px]'>
            <div>
                <Label value="First Name"></Label>
                <TextInput id="first-name" shadow required onChange={handleFirstNameChange}/>
            </div>
            <div>
                <Label value="Last Name"></Label>
                <TextInput id="last-name" shadow required onChange={handleLastNameChange}></TextInput>
            </div>
            <div>
                <Label value="Email"></Label>
                <TextInput id="email" shadow="true" required type='email' onChange={handleEmailChange}></TextInput>
            </div>
            <div>
                <Label value="Password"></Label>
                <TextInput id="password" shadow="true" required type='password' onChange={handlePasswordChange}
                    
                ></TextInput>
            </div>
            
           <div>
                <Label value="Confirm Password"></Label>
                <TextInput id="confirm-password" shadow="true" required type='password' onChange={handleConfirmPasswordChange} helperText={confirmPassword === password ? "" : "Passwords must match"}></TextInput>
           </div>
           <div>
                <Label value="Phone Number"></Label>
                <TextInput id="phone-number" shadow="true" required type='text' onChange={handlePhoneNumberChange}></TextInput>
           </div>
            <div>
                <Flowbite>
                    <Label
                    htmlFor="file"
                    value="Profile Picture"
                    />
                    <FileInput
                        id="file"
                        onChange={e => setFile(e.target.files[0])}
                    />
                </Flowbite>
            </div>
            <div className='flex flex-row items-center gap-2 mt-10'>
                <Checkbox
                defaultChecked
                id="accept"
                required
                />
                <Label
                className="flex"
                htmlFor="accept"
                >
                <p>
                    I agree with the <span className="underline" onClick={() => props.setOpenModal('dismissible')}>terms and conditions</span>
                </p>
                
                </Label>
            </div>
            <Flowbite theme={{ theme: buttonTheme }}>
                <Button disabled={confirmPassword !== password} color="primary" className='w-full' type='submit'> Create Account</Button>
            </Flowbite>
        </form>

        <Modal dismissible show={props.openModal === 'dismissible'} onClose={() => props.setOpenModal(undefined)}>
        <Modal.Header>Terms of Service</Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
              With less than a month to go before the European Union enacts new consumer privacy laws for its citizens,
              companies around the world are updating their terms of service agreements to comply.
            </p>
            <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
              The European Union’s General Data Protection Regulation (G.D.P.R.) goes into effect on May 25 and is meant to
              ensure a common set of data rights in the European Union. It requires organizations to notify users as soon as
              possible of high-risk data breaches that could personally affect them.
            </p>
          </div>
        </Modal.Body>
      </Modal>
        <Footer/>
    </div>
  )
}
